import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { BlankWorkSpaceComponent } from './blank-work-space.component';

@NgModule({
    declarations: [
        BlankWorkSpaceComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
    ],
    exports: [
        BlankWorkSpaceComponent,
    ]
})
export class BlankWorkSpaceModule { }
